export default __webpack_public_path__ + "static/media/product1.a8e6074b.jpg";